<template>
  <v-container>
    <a id="characterclick" v-on:click="onClickCharacter">
        <v-icon class="playbutton buttonoverlay"
            v-if="mobileStalled">
            play_circle_outline
        </v-icon>
        <v-layout>
        <v-flex xs12 >
            <v-card>
            <v-responsive>
                <div id="apng" ref="apng" ></div>
            </v-responsive>
            </v-card>
        </v-flex>
        </v-layout>
    </a>
  </v-container>
</template>

<script>
// import Play from '../../tts/play'
import Clip from '../../tts/clip'
import APNGLoader from '../../apng'
import {SmoothContext} from 'smooth-script'
import Face from '../../tts/face'

export default {
  name: 'character-player',
  props: {
  },
  data () {
    return {
      mobileStalled: false,
      loadedCanvasIds: {}
    }
  },
  computed: {
    allfaces () {
      return this.$store.getters['main/allfaces']
    }
  },
  methods: {
    onClickCharacter: function () {
      this.$emit('characterClick')
      this.mobileStalled = false
    },
    changeCharacter: function (id, playbackRate, onError) {
      var onLoaded = (canvas) => {
        if (this.currentCanvas) {
          this.currentCanvas.style.display = 'none'
        }
        this.currentCanvas = canvas
        this.currentCanvas.style.display = 'block'
        this.player = this.currentCanvas.apng_player
        if (this.player) {
          this.player.playbackRate = playbackRate
        }
      }
      this.APNGLoader.loadAPNG(id, this.allfaces[id].apng, onLoaded, onError)
    },
    onCanvasAdded: function (id) {
      var apngdiv = this.$refs['apng']
      var canvas = APNGLoader.cachedAPNG[id]
      if (canvas) {
        // Make sure we only call this once.
        if (!(id in this.loadedCanvasIds)) {
          this.loadedCanvasIds[id] = true
          canvas.style.display = 'none'
          if (apngdiv) {
            apngdiv.appendChild(canvas)
          } else {
            throw new Error('ANPG Div not ready')
          }
        }
      } else {
        throw new Error('NULL Canvas')
      }
    },
    loadCharacter: function (id, onSuccess, onError) {
      if (id in this.allfaces) {
        let face = this.allfaces[id]
        let playbackRate = 1.0
        if (face && face.speed) {
          playbackRate = face.speed
        }
        ;((playrate) => {
          var onLoadedSuccess = (canvas) => {
            this.onCanvasAdded(canvas.id)
            if (onSuccess) {
              onSuccess()
            }
            // At least we've loaded one...
            this.$emit('loading', false)
          }
          var onLocalError = (error) => {
            if (error) {
              console.warn(error)
            }
            // Try again with default
            this.APNGLoader.loadAPNG(id, Face.defaultAPNG, onLoadedSuccess, onError)
          }
          this.$emit('loading', true)

          this.APNGLoader.loadAPNG(id, face.apng, onLoadedSuccess, onLocalError)
        })(playbackRate)
      } else {
        if (onError) {
          onError(new Error('Unknown face in loadCharacter: ' + id))
        } else {
          throw new Error('Unknown face in loadCharacter: ' + id)
        }
      }
    },
    onClipStartEvent: function (clip) {
      var face = this.allfaces[clip.faceId]
      if (face) {
        let playbackRate = 1.0
        if (face.speed) {
          playbackRate = face.speed
        }
        this.changeCharacter(clip.faceId, playbackRate, () => {
          this.changeCharacter('default', 1.0)
        })
      } else {
        this.changeCharacter('default', 1.0)
      }

      if (this.recognition) {
        this.stopRecognition()
      }
    },
    onFaceId: function (faceId) {
      if (faceId) {
        var face = this.allfaces[faceId]
        if (face) {
          let playbackRate = 1.0
          if (face.speed) {
            playbackRate = face.speed
          }
          this.changeCharacter(faceId, playbackRate, () => {
            this.changeCharacter('default', 1.0)
          })
        } else {
          this.changeCharacter('default', 1.0)
        }
      } else if (this.currentCanvas) {
        this.currentCanvas.style.display = 'none'
      }
    },
    onUtteranceStartEvent: function (object) {
      this.mobileStalled = false
      this.loading = false
      if (this.player) {
        this.player.play_for_duration(object.duration)
      }
    },
    onStalledEvent: function () {
      this.mobileStalled = true
    }
  },
  created: function () {
    Clip.eventEmitter.addListener('utterancestart', this.onUtteranceStartEvent)
    Clip.eventEmitter.addListener('stalled', this.onStalledEvent)
    SmoothContext.eventEmitter.addListener('faceId', this.onFaceId)
    this.APNGLoader = new APNGLoader()
  },
  beforeDestroy: function () {
    Clip.eventEmitter.removeListener('utterancestart', this.onUtteranceStartEvent)
    Clip.eventEmitter.removeListener('stalled', this.onStalledEvent)
    SmoothContext.eventEmitter.removeListener('faceId', this.onFaceId)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Playback/CharacterPlayer.vue